import * as React from 'react';
/**
 *
 * Original name: Dropbox Passwords
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=14398%3A93
 *
 */
export const DropboxPasswordsLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M11.435 14.42c-1.306-.146-2.032-1.017-2.032-2.42s.726-2.226 2.032-2.42V6H5v3.58c1.548 0 2.42.872 2.42 2.42S6.547 14.42 5 14.42V18h6.435v-3.58Zm7.888 0c-1.549 0-2.42-.872-2.42-2.42s.871-2.42 2.42-2.42V6h-6.436v3.58c1.306.146 2.032 1.017 2.032 2.42 0 1.452-.726 2.274-2.032 2.42V18h6.436v-3.58Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
